<template>
    <div class="toolbar toolbar-texture"
         style="margin-bottom: 0;"
    >
        <div v-for="variant in variants"
             class="button"
             :data-tooltip="variant.color.name"
             :class="{'selected': product.color.id === variant.color.id }"
             style="width: 50px; height: 50px;"
             @click="goToProduct($event, variant)"
        >
            <label>
                <responsive-image
                    v-if="variant.variantImage"
                    :media="variant.variantImage"
                    :alt="variant.color.name"
                    classes="color-image"
                    width="50px"
                    height="50px"
                    style="margin-top: -3px;"
                />
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ProductItemVariantsPicker',

    props: {
        product: {
            type: Object,
        },

        variants: {
            type: Array
        },
    },

    methods: {
        goToProduct(event, variant) {
            event.stopPropagation()
            event.preventDefault()

            window.location.href = variant.url
        },
    },
}
</script>

<style scoped>

</style>
